import { Stack, Typography, Switch } from '@mui/material';
import React from 'react';

function HospitalSiteFeatures(props) {
    function handleToggleConfig(configName) {
        const configs = { ...props.hospitalData.configurations };

        configs[configName] = !configs[configName];

        props.setHospitalData({
            ...props.hospitalData,
            configurations: configs
        });
    }

    function isConfigActive(config) {
        return config === true;
    }

    return (
        <Stack p={2} spacing={2}>
            <Typography variant='heavy' fontSize='18px'>Hospital Feature Flags</Typography>
            { Object.keys(props.hospitalData.configurations).length === 0 && (
                <Typography variant='normal' sx={{ fontSize: '16px' }}><em>Note: Setting feature flags is only possible after hospital creation.</em></Typography>
            )}
            { Object.entries(props.hospitalData.configurations).map(([configName, config]) => (
                <Stack direction='row' justifyContent='space-between' alignItems='center' key={configName}>
                    <Typography variant='normal' sx={{ fontSize: '16px' }}>{configName}: <strong>{isConfigActive(config) ? 'Enabled' : 'Disabled'}</strong></Typography>
                    <Switch checked={isConfigActive(config)} onChange={() => handleToggleConfig(configName)} />
                </Stack>
            ))}
        </Stack>
    );
}

export default HospitalSiteFeatures;
